import React from 'react'
import Left from '../../assets/Icons/Back.svg'
import Right from '../../assets/Icons/Forward.svg'
import { autocorrectionPreferences } from '../../classes/KeyboardSettings.js'
import './AutocorrectionPreference.css'

export const AutocorrectionPreference = ({ value = 3, onChange }) => {
  const preference = autocorrectionPreferences[value - 1] || autocorrectionPreferences[2]
  return <div className='autocorrectionPreference' role='radiogroup'
    aria-label='Auto-Correction preference' aria-describedby='autocorrection-description'>
    <span className='autocorrectionPreferenceEndpoint' aria-hidden='true'>Suggest</span>
    {autocorrectionPreferences.map((option, index) => <label
      key={index} className='autocorrectionPreferenceSegment' title={`${index + 1} — ${option.label}`}>
      <input type='radio' name='autocorrection-preference' value={index + 1}
        checked={value === index + 1} aria-label={`${index + 1} — ${option.label}`}
        onChange={() => onChange(index + 1)}/>
      <span aria-hidden='true'>{index === 0 || index === 4
        ? <img src={index === 0 ? Left : Right} alt=''/>
        : <i className='autocorrectionPreferenceDot'/>}</span>
    </label>)}
    <span className='autocorrectionPreferenceEndpoint' aria-hidden='true'>Correct</span>
    <span className='autocorrectionPreferenceDescription' id='autocorrection-description'>
      {preference.description}
    </span>
  </div>
}
